export const REQUEST_FAVOURITES = 'app/User/Favourites/REQUEST_FAVOURITES';
export const RECEIVE_FAVOURITES_PRODUCTS = 'app/User/Favourites/RECEIVE_FAVOURITES';
